<page-toolbar [pageActions]="pageActions" title="Dashboard Messages Overview"></page-toolbar>

<page-content>
  <data-table #table (edit)="onEdit($event)" (remove)="onRemove($event)" [columns]="columns" [dataProvider]="dashboardMessageService"
                  [searchAll]="true" title="Dashboard messages">
  </data-table>
</page-content>
